<template>
    <div>
        <loading v-show="isLoading"></loading>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="success" @click="getExl" icon="el-icon-download" size="small" plain>导出结果</el-button>

                        <el-select size="small" filterable   style="margin-left:20px;width:100px"   v-model="queryModel.outsiderId" clearable placeholder="兼职人员">
                            <el-option v-for="(v) in outsiderList" :key="v.Id" :label="v.Name" :value="v.Id"> </el-option>
                        </el-select>

                        <el-date-picker
                        @change="query"
                        :clearable="false"
                        size="small" 
                        style="width:300px;margin-left:20px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>

                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.type" clearable placeholder="交易类型">
                            <el-option label="收入" :value="1"> </el-option>
                            <el-option label="转账" :value="2"> </el-option>
                            <el-option label="多转" :value="3"> </el-option>
                        </el-select>

                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <template>
                            <b style="font-size:13px;margin-left:20px">总计：</b>
                            <el-tag class="tag_btn" size="mini"  type="danger" effect="dark">￥{{moneyTotal.toFixed(2)}}</el-tag>
                        </template>

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :height="bodyHeight-130"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            prop="Description"
                            label="摘要">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            label="出纳手机">
                        </el-table-column>
                        <el-table-column
                            prop="Name"
                            label="出纳姓名">
                        </el-table-column>
                        <el-table-column
                            label="金额">
                            <template slot-scope="scope">
                                    <el-link :type="scope.row.Money>0?'danger':'success'">￥{{scope.row.Money.toFixed(2)}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="交易后余额">
                            <template slot-scope="scope">
                                <el-link type="warning">￥{{scope.row.Balance.toFixed(2)}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            label="交易时间">
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { outsiderGetRecord,outsiderGetSel,uri} from '@/request.js'
import { formatDate } from '@/commonUtil.js'

export default {
    components: {
    },
    props:{

    },
    data(){
        return {
            outsiderList:[],
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                outsiderId:"",
                type:"",
                createTimes:[],
                pSize:20,
                pIndex:1,
            },
            tableData:[],
            moneyTotal:0,
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        
    },
    mounted(){
        var date=new Date();
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        outsiderGetSel({type:1},(res)=>{
           this.outsiderList=res.Result;
       });
        this.query();
    },
    methods: {
        getExl(){
            let arr=[]
            this.queryModel.createTimes.forEach(x=>{
                console.log(x);
                arr.push(formatDate(new Date(x),"yyyy-MM-dd"))
            });
           window.open(uri+"/Outsider/GetRecordExl?outsiderId="+(this.queryModel.outsiderId==""?0:parseInt(this.queryModel.outsiderId))+"&type="+(this.queryModel.type==""?0:parseInt(this.queryModel.type))+"&createTimes="+(this.queryModel.createTimes==null?"[]":JSON.stringify(arr))
           );
       },
        query(){
            this.isLoading=true;
            let arr=[]
            this.queryModel.createTimes.forEach(x=>{
                console.log(x);
                arr.push(formatDate(new Date(x),"yyyy-MM-dd"))
            });
            outsiderGetRecord({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                outsiderId:this.queryModel.outsiderId==""?0:parseInt(this.queryModel.outsiderId),
                type:this.queryModel.type==""?0:parseInt(this.queryModel.type),
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(arr),
            },(res)=>{
                this.tableData=res.Result.List;
                this.moneyTotal=res.Result.Total;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                type:1,
                createTimes:[],
                pSize:20,
                pIndex:1,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>